<i class="icon icon-tank{{tankType()}}" [ngClass]="inputClass()"></i>
